import type { IconProps } from '../types'

export const VictoryIcon = ({
  size,
  color = 'currentColor',
  strokeWidth = 2,
  ...rest
}: IconProps) => (
  <svg
    {...rest}
    focusable={false}
    width={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11L11 3.72792C11 3.26184 11.1851 2.81485 11.5147 2.48528C12.5387 1.46129 14.2923 2.04581 14.4971 3.47939L16 10L17.5081 3.6723C17.7769 2.75853 18.7501 2.25003 19.6537 2.55123C20.4313 2.81044 20.9088 3.59248 20.7842 4.40265L19 16"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 16C18.4643 20 15.6421 22 11.5 22C7.35786 22 4 20 4 16"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M4 16V12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12M12 13V11C12 9.89543 11.1046 9 10 9C8.89543 9 8 9.89543 8 11V15"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6923 17H11C9.89543 17 9 16.1046 9 15C9 13.8954 9.89543 13 11 13L15 13C17.2091 13 19.5 15 18.5 18"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
